export default __webpack_public_path__ + "static/media/Perimeter-Protection-System.25353260.jpg";